import { getExcelDate } from "./commonHelper";
// import { generateUniqueStringWithTime } from "./gigHelpers";

/**
 * Generates an array of person objects with dynamic birthDates.
 * @param {Array<{count: number, age: number}>} groups
 * @returns {Array<{ person: { member_first_name: string,member_gender: string,member_dob:string,member_pass_num:string  } }>}
 */
export const createTakafulPeopleArrayFromGroups = (groups) => {
  let globalIndex = 0;

  return groups.flatMap(({ count, age }) => {
    const birthDate = new Date();
    birthDate.setFullYear(birthDate.getFullYear() - age);
    const formattedDate = getExcelDate(birthDate);

    return Array.from({ length: count }, () => {
      const person = {
        member_first_name: "Dev" + globalIndex,
        member_gender: "Male",
        member_dob: formattedDate,
        member_pass_num: "SX123456" + globalIndex,
      };
      globalIndex++;
      return person;
    });
  });
};

export const generateCovers = (data, product_id, sub_product_id) => {
  const covers = [];
  if (product_id === 1 && (sub_product_id === 1 || sub_product_id === 21)) {
    for (let i = 1; i <= 17; i++) {
      const key = `cover_${i}_name`;
      const keyPrem = `cover_${i}_prem`;
      const value = data[key];
      const prem = data[keyPrem];

      if (value && value.trim() !== "") {
        covers.push({ cover_description: value.trim(), cover_coverage: prem });
      }
    }
  } else {
    Object.keys(data).forEach((key) => {
      if (key.endsWith("_h")) {
        const baseKey = key.slice(0, -2); // remove '_h'
        const cover_description = data[key];
        const cover_coverage = data.hasOwnProperty(baseKey)
          ? data[baseKey]
          : null;

        // Only include if cover_coverage is not null or undefined
        if (cover_coverage !== null && cover_coverage !== undefined) {
          covers.push({
            cover_description,
            cover_coverage,
          });
        }
      }
    });
  }

  return covers;
};

export const prepareTakafulInsuranceCardData = (
  companyList,
  travelProductType
) => {
  let data = [];
  if (companyList && companyList.length) {
    companyList.forEach((company, index) => {
      if (
        company?.product_id === 1 &&
        (company?.sub_product_id === 1 || company?.sub_product_id === 21)
      ) {
        let cells = company?.extracted_data?.cells || [];
        console.log("Takaful Helpers :: company :: ", { company });

        if (company?.extracted_data?.tax_details?.tax_parts[0]?.amount > 0) {
          data.push({
            product_id: company?.product_id,
            sub_product_id: company?.sub_product_id,
            object_id: index,
            company_name: company?.insurance_company?.company_title,
            company_name_ar: company?.insurance_company?.company_title_ar,
            company_description_en:
              company?.insurance_company?.company_descriptions_en,
            company_description_ar:
              company?.insurance_company?.company_descriptions_ar,
            company_faq_en: company?.insurance_company?.faq_en,
            company_faq_ar: company?.insurance_company?.faq_ar,
            company_id: company?.insurance_company?.id,
            company_image: company?.insurance_company?.image,
            email: company?.extracted_data?.email,
            mobile_no: company?.extracted_data?.mobile_no,
            plan_name: "Silver",
            // base_price: cells?.premium_value || 0,
            // premium_value: cells?.premium_value || 0,
            base_price:
              company?.extracted_data?.tax_details?.tax_parts[0]?.amount?.toFixed(
                3
              ) || 0,
            premium_value: (
              (parseFloat(
                company?.extracted_data?.tax_details?.tax_parts[0]?.amount
              ) || 0) +
              (parseFloat(
                company?.extracted_data?.tax_details?.tax_parts[0]?.value
              ) || 0)
            ).toFixed(3),
            premium_currency: "OMR",
            included_covers: generateCovers(
              cells,
              company?.product_id,
              company?.sub_product_id
            ),
            // optional_covers: [
            //   {
            //     cover_description: "Claim Nil Access",
            //     isSelected:
            //       company?.extracted_data?.nil_excess_loading === "Yes"
            //         ? true
            //         : false,
            //   },
            //   {
            //     cover_description: "Sports Activities",
            //     isSelected:
            //       company?.extracted_data?.sport_activity_loading === "Yes"
            //         ? true
            //         : false,
            //   },
            //   {
            //     cover_description: "TopUp benefits",
            //     isSelected:
            //       company?.extracted_data?.top_up_benefits_loading === "Yes"
            //         ? true
            //         : false,
            //   },
            // ],
            optional_covers: [],
            extracted_data: company?.extracted_data || {},
            insurance_company_product_mapping_id: company?.id,
          });
        } else {
          console.error("Takaful:: Premium value is Zero");
        }
      } else {
        let cells = company?.extracted_data?.cells || [];
        let travel_product_type =
          travelProductType && travelProductType.length
            ? travelProductType[0]?.options
            : [];

        data.push({
          product_id: company?.product_id,
          sub_product_id: company?.sub_product_id,
          object_id: index,
          company_name: company?.insurance_company?.company_title,
          company_name_ar: company?.insurance_company?.company_title_ar,
          company_description_en:
            company?.insurance_company?.company_descriptions_en,
          company_description_ar:
            company?.insurance_company?.company_descriptions_ar,
          company_faq_en: company?.insurance_company?.faq_en,
          company_faq_ar: company?.insurance_company?.faq_ar,
          company_id: company?.insurance_company?.id,
          company_image: company?.insurance_company?.image,
          email: company?.extracted_data?.email,
          mobile_no: company?.extracted_data?.mobile_no,
          plan_name: "Silver",
          base_price: company?.fixed_rate_value || 0,
          premium_value: company?.fixed_rate_value || 0,
          premium_currency: "OMR",
          included_covers: generateCovers(
            cells,
            company?.product_id,
            company?.sub_product_id
          ),
          optional_covers: [
            {
              cover_description: "Claim Nil Access",
              isSelected:
                company?.extracted_data?.nil_excess_loading === "Yes"
                  ? true
                  : false,
            },
            {
              cover_description: "Sports Activities",
              isSelected:
                company?.extracted_data?.sport_activity_loading === "Yes"
                  ? true
                  : false,
            },
            {
              cover_description: "TopUp benefits",
              isSelected:
                company?.extracted_data?.top_up_benefits_loading === "Yes"
                  ? true
                  : false,
            },
          ],
          extracted_data: company?.extracted_data || {},
          insurance_company_product_mapping_id: company?.id,
          area_of_coverage:
            travel_product_type.find(
              (tp) => tp.company == company?.insurance_company?.id
            ) || null,
        });
      }
    });
  }

  return data;
};

export const prepareTakafulMotorPremiumCalInputs = (vehicleData, formData) => {
  let productDetail = localStorage.getItem("product_details")
    ? JSON.parse(localStorage.getItem("product_details"))
    : null;

  let plan_type;
  if (productDetail && productDetail?.sub_product_id === 21) {
    plan_type = "Comprehensive";
  } else {
    // if (
    //   vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse?.GetVehicleValuationByPlateResult?.VehicleInfo?.InsuranceTypeDesc.toLowerCase().includes(
    //     "third"
    //   )
    // ) {
    //   plan_type = "Third party";
    // } else if (
    //   vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse?.GetVehicleValuationByPlateResult?.VehicleInfo?.InsuranceTypeDesc.toLowerCase().includes(
    //     "comprehensive"
    //   )
    // ) {
    //   plan_type = "Comprehensive";
    // }
    plan_type = "Third party";
  }

  let ropVehicleVinDecoding =
    vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
      ?.GetVehicleValuationByPlateResult?.result?.vin_decoding;

  let vehicleDescription =
    vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
      ?.GetVehicleValuationByPlateResult?.result?.vehicle_description
      ?.Vehicle_Description;
  let ropVehicleDescription;
  if (Array.isArray(vehicleDescription)) {
    ropVehicleDescription = vehicleDescription?.find(
      (item) => item?.admeid === ropVehicleVinDecoding?.admeid
    );
  } else {
    ropVehicleDescription = vehicleDescription;
  }

  // NOTES
  // 1. if premium_value=0 then change plan_type = Third party and plan_name = Custom TP and re-generate Premium calc API again
  // 2. where ever "" then value not needed.
  // 3. Covers to be displayed from the cover_[Number]_name and only that has value against the cover.
  let inputs = {
    product_id: "M000000000004",
    plan_type, // pick this value from auto data <InsuranceTypeDesc> pick only words Third party or Comprehensive
    plan_name: plan_type === "Third party" ? "Custom TP" : "Custom Comp", // if plan_type = "Third party" then "Custom TP" else "Custom Comp"
    is_it_a_brandnew_vehicle: "No",
    rop_flag: "No",
    vehicle_seating: ropVehicleDescription?.seats?.match(/\d+/)?.[0] || "", // go to <vin_decoding> in auto data and pick <admeid> value. Then go to <vehicle_description> and look for the selected <admeid> value and take numerical value from <seats>
    vehicle_cubic_capacity: (ropVehicleVinDecoding?.engine_size / 10) * 1000, // go to <vin_decoding> in auto data and pick <engine_size>. (That value / 10)*1000 is the value that needs to come here
    vehicle_make:
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.VehicleInfo?.VehicleMakeDesc, //go to <VehicleInfo>  in auto data and pick value in <VehicleMakeDesc>
    vehicle_model:
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.VehicleInfo?.VehicleModelDesc, //go to <VehicleInfo>  in auto data and pick value in <VehicleModelDesc>
    vehicle_mfg_year:
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.VehicleInfo?.MakeYear, //go to <VehicleInfo> in auto data <MakeYear>
    body_type:
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.VehicleInfo?.VehicleTypeDesc, //go to <VehicleInfo> in auto data <VehicleTypeDesc>
    insured_vechile_value:
      plan_type === "Comprehensive" ? formData?.vehicle_valuation : "", // blank if third party. If Comphrehensive pick value from 2.GIG_Veh_Valuation
    ncb: "0",
    additional_accessories: "No",
    accessories_si: "",
    agency_repair: plan_type === "Third party" ? "No" : "Yes", // "No" if third party. "Yes" If Comphrehensive
    pab: "Yes",
    oman_gcc: "No",
    uae_extension:
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse?.GetVehicleValuationByPlateResult?.VehicleInfo?.InsuranceTypeDesc?.includes(
        "OMAN AND U A E"
      )
        ? "Yes"
        : "No", // In auto data if <InsuranceTypeDesc> contains the value "OMAN AND U A E" Then Yes else No
    tp_bi: "Yes",
    tp_pd: "Yes",
    rsa_standard: "No",
    orange_card: "No",
    thirdparty_pd: "No",
    rsa_car_replacement: "No",
    nil_excess: "No",
    front_wind_shield: "No",
    stf_cover: "No",
    customer: {
      insured_dob: getExcelDate(
        vehicleData?.ropLicense?.Body?.GetLicenseInfoResponse
          ?.GetLicenseInfoResult?.DateofBirth
      ), // from ROP license info <DateofBirth>
      civil_resident_id:
        vehicleData?.ropLicense?.Body?.GetLicenseInfoResponse
          ?.GetLicenseInfoResult?.LicenseNumber, // from ROP license info <LicenseNumber>
      title: "Mr",
      first_name: "fardin",
      last_name: "test",
      email: "divyesh.dev@yopmail.com",
      mobile_no: "93203393",
    },
    branch_code: "100",
    plate_char:
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.VehicleInfo?.PlateCode, // <PlateCode> from Auto data
    plate_number:
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.VehicleInfo?.PlateNumber, // <PlateNumber> from auto data
    mulkiya_barcode: "",
    mulkiya_date: getExcelDate(
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.VehicleInfo?.RegistrationEndDate
    ),
    chassis_no:
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.VehicleInfo?.ChassisNumber,
    // chassis_no: generateUniqueStringWithTime(),
    vehicle_engine_no:
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.VehicleInfo?.EngineNumber,
    vehicle_color:
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.VehicleInfo?.ColorDesc,
    gcc_spec: "",
    prev_policy_type: plan_type,
    prev_vechile_value: plan_type === "Third party" ? "" : 0, //call gig_valuation api and get <GIG_Veh_Valuation> value
    previous_insurance:
      vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
        ?.GetVehicleValuationByPlateResult?.VehicleInfo?.InsuranceCompanyName,
    insured_license_issue_date:
      vehicleData?.ropLicense?.Body?.GetLicenseInfoResponse
        ?.GetLicenseInfoResult?.DateFirstIssued,
    insured_license_expire_date: getExcelDate(
      vehicleData?.ropLicense?.Body?.GetLicenseInfoResponse
        ?.GetLicenseInfoResult?.DateofExpiry
    ),
    any_claim_in_pre_policy: "",
    place_issue:
      vehicleData?.ropLicense?.Body?.GetLicenseInfoResponse
        ?.GetLicenseInfoResult?.PlaceOfIssue, // <PlaceOfIssue> from licenseinfo
    specification: ropVehicleVinDecoding?.spec,
  };
  return inputs;
};

export const getClaimDetails = (vehicleData) => {
  const autoData =
    vehicleData?.ropVehicle?.Body?.GetVehicleValuationByPlateResponse
      ?.GetVehicleValuationByPlateResult;

  const result = {
    claim_res_yn: "No",
    term_1: "No",
    term_2: "No",
    term_3: "No",
    term_4: "No",
    term_5: "No",
    any_claim_in_pre_policy: "No",
  };

  if (!autoData || !Array.isArray(autoData.Claimdetails)) return result;

  const sortedClaims = [...autoData.Claimdetails]
    .filter((claim) => claim.AccidentIntimationDate)
    .sort(
      (a, b) =>
        new Date(b.AccidentIntimationDate) - new Date(a.AccidentIntimationDate)
    );

  const topClaims = sortedClaims.slice(0, 5);

  if (topClaims.length > 0) {
    result.claim_res_yn = "Yes";
    for (let i = 0; i < topClaims.length; i++) {
      result[`term_${i + 1}`] = "Yes";
    }
  }

  // Check for any claim within policy duration
  const hasClaimInPrePolicy = autoData.Claimdetails.some((claim) => {
    if (
      claim.AccidentIntimationDate &&
      claim.InsuranceStartDate &&
      claim.InsuranceEndDate
    ) {
      const accidentDate = new Date(claim.AccidentIntimationDate);
      const startDate = new Date(claim.InsuranceStartDate);
      const endDate = new Date(claim.InsuranceEndDate);
      return accidentDate >= startDate && accidentDate <= endDate;
    }
    return false;
  });

  if (hasClaimInPrePolicy) {
    result.any_claim_in_pre_policy = "Yes";
  }

  return result;
};
const blobToBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result.split(",")[1]); // pure base64
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

export const fetchDownloadAndSendPDF = async (
  pdfUrl,
  token,
  onBase64Ready
) => {
  const response = await fetch(pdfUrl, {
    method: "GET",
    headers: { "in-auth-token": token },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const blob = await response.blob();
  const base64Pdf = await blobToBase64(blob);

  onBase64Ready(base64Pdf); // ✅ callback only
};



export const fetchAndDownloadTakafulPDF = async (pdfUrl, filename, token) => {
  try {
    const response = await fetch(pdfUrl, {
      method: "GET",
      headers: {
        // 'Content-Type': 'application/pdf',
        "in-auth-token": token,
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename || "download.pdf");
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  } catch (error) {
    console.error("Error downloading PDF:", error);
  }
};

//for travel mem_details
export const transformMembers = (members) => {
  return members.map((m, index) => ({
    member_first_name: m.first_name,
    member_last_name: m.last_name,
    member_dob: getExcelDate(m.insured_dob),
    member_pass_num: m.passport_number,
    member_gender: m.gender,
    ...(index === 0 ? { index } : {}), // add index only for first
  }));
};
